import React from "react";

function MiniRow({ what, where, meta }) {
  return (
    <div className="minirow">
      <div>
        <span className="mr-what">{what}</span>
        {where ? <span className="mr-where"> · {where}</span> : null}
      </div>
      <span className="mr-meta">{meta}</span>
    </div>
  );
}

export default function Education({ items }) {
  return (
    <div className="minilist">
      {items.map((e) => (
        <MiniRow key={e.what} what={e.what} where={e.where} meta={e.dates} />
      ))}
    </div>
  );
}
